/**
 * List of specialty names that have corresponding SVG icons
 * in the public/specilities-icons directory
 */
export const availableSpecialtyIcons = [
  'أمراض الدم و الأورام لدى الأطفال',
  'الطب الباطني',
  'المعالجة الإشعاعية',
  'برنامج زراعة الأمعاء',
  'برنامج زراعة البنكرياس',
  'برنامج زراعة الرئة',
  'برنامج زراعة الكبد',
  'برنامج زراعة الكلى',
  'بنك العظام',
  'جراحة العظام',
  'طب الأسنان',
  'طب الأطفال',
  'طب الرعاية الحرجة',
  'طب العائلة والعيادات الشاملة',
  'علم الأمراض والطب المخبري',
  'قسم الأذن والأنف والحنجرة، جراحة الرأس والعنق و علوم التواصل',
  'قسم التخدير',
  'قسم الجراحة',
  'قسم الجلدية',
  'قسم الطوارئ',
  'قسم المسالك البولية',
  'قسم النساء والولادة',
  'مركز التوحد',
];
